import React, {FunctionComponent} from "react";
import {CustomDialog, Text} from "@bounce/shared/ui";
import NiceModal, {NiceModalHocProps, useModal} from "@ebay/nice-modal-react";

interface SwitchPartnerDialogProps extends NiceModalHocProps {
  onConfirm: () => void;
  partnerName: string;
}

const SwitchPartnerDialog: FunctionComponent<SwitchPartnerDialogProps> = NiceModal.create(({onConfirm, partnerName}) => {
  const modal = useModal();

  const handleStayHere = () => {
    modal.resolve(false);
    modal.hide();
  };

  const handleSwitch = () => {
    onConfirm();
    modal.resolve(true);
    modal.hide();
  };

  return (
    <CustomDialog
      title="Switch partnership type"
      onClick={handleSwitch}
      buttonText="Switch"
      secondaryButtonText="Not now"
      onClickSecondary={handleStayHere}
      width="400px"
      alignCenter
      autoClose={false}
    >
      <Text size={14} sx={{textAlign: "center", lineHeight: "20px"}}>
        You're about to view the <strong>{partnerName}</strong> partnership. Some data and available actions may change.
      </Text>
    </CustomDialog>
  );
});

export default SwitchPartnerDialog;
